import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { fileQueryKeys } from "./fileQueryKeys";

type DeleteDirectoryMutationArgs = {
  directoryPaths: string[];
  associationId: string;
};

export function useDeleteDirectoryMutation(): UseMutationResult<
  void,
  unknown,
  DeleteDirectoryMutationArgs
> {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();
  return useMutation<void, unknown, DeleteDirectoryMutationArgs>({
    mutationFn: ({ directoryPaths, associationId }) => {
      return fileService.deleteDirectories(associationId, directoryPaths);
    },
    // The folders' files are gone with them, and the lookups behind the
    // Overridden labels and the URDF preview may have named some of them.
    onSuccess: (_void, { associationId }) => {
      void queryClient.invalidateQueries({
        queryKey: fileQueryKeys.lookups(associationId),
      });
    },
  });
}
